import React from 'react';
import * as styles from './detailedCurriculum.module.scss';
import ProjectCard from './ProjectCard';
import { OPTIONAL_BUILD_DETAILS } from './projectDetailsData';

const OptionalBuilds = () => {
  return (
    <section id="optbuilds" className={styles.mint}>
      <div className={styles.wrap}>
        <h2 className={styles.secH}>
          Part 3 — <span className={styles.g}>optional self-builds.</span>
        </h2>
        <p className={styles.secSub}>
          Available from Sprint 5 or after the program. Each comes with a scaffold, a rubric and
          light mentor checkpoints, and produces the same delivery artefacts as the guided
          projects. Two are regulated-vertical builds (spec → build → deploy with compliance
          controls). Together they cover the four enterprise patterns most common in job
          descriptions: document-heavy decisioning, regulated co-pilots, speech-analytics
          pipelines, and agents over structured data.
        </p>
        {OPTIONAL_BUILD_DETAILS.map((p) => (
          <ProjectCard p={p} key={p.id} />
        ))}
      </div>
    </section>
  );
};

export default OptionalBuilds;
